<template>
  <!-- Modale per la visualizzazione delle transazioni annullate -->
  <div>
    <b-modal size="xl"
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close
             title="Transazioni annullate."
             @show="init_modal_data"
             v-model="open_close_modal">
      <template v-slot:default>
        <b-row>
          <b-col>
            <p>
              Questa è la lista degli acquisti annullati dai nostri operatori backoffice. Puoi recuperare i dati che hai inserito
              nel form cliccando sull'icona <font-awesome-icon class="replay-button" icon="registered"/> accanto all'id della transazione.<br/>
              Solo per le transazioni con questa icona è possibile recuperare le precedenti informazioni, quelle annullate più di recente
              sono riportate per prime.
            </p>
          </b-col>
        </b-row>
        <b-row>
          <!-- QUI IL FILTRO ED IL NUMERO DI RIGHE DA VISUALIZZARE -->
          <b-col md="3">
            <!-- Select per il numero di elementi da visualizzare -->
            <b-form-group id="group-page-size"
                          label="Elementi visualizzati:"
                          label-for="page-size">
              <b-form-select id="page-size"
                      v-model="datatable.page_size"
                      :options="datatable.page_size_opt">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <!-- Input box per filtraggio elementi per stringa -->
            <b-form-group id="group-filtro-tabella"
              label="Ricerca per termine:"
              label-for="filtro_tabella"
              description="Digita per ricercare all'interno degli elementi della tabella">
              <b-form-input
                id="filtro_tabella"
                v-model="datatable.filter">
                </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- QUI LA TABELLA --->
            <!-- no-provider-sorting e no-provider-filtering evita che per ogni azione
                di sorting o filtraggio venga chiamato il backend, ma venga fatto dalla
                tabella stessa. -->
            <b-table responsive
                    :items="get_table_items"
                    :no-provider-filtering="true"
                    :no-provider-sorting="true"
                    :per-page="datatable.page_size"
                    :current-page="datatable.current_page"
                    :fields="datatable.fields"
                    :filter="datatable.filter"
                    show-empty>

              <!-- Slot per la prima colonna, sostituisce l'id del kind con l'icona di font awesone definita per il tipo di acquisto -->
              <template v-slot:cell(kind)="data">
                <font-awesome-icon size="lg"
                  v-b-tooltip.hover.bottom="row_attributes[ data.item.kind ].tooltip_text"
                  :icon="row_attributes[ data.item.kind ].fa_icon"
                  :style="row_attributes[ data.item.kind ].fa_icon_style"/>
              </template>

              <!-- Slot per la colonna id_acquisto. Se la tipologia di acquisto ammette la funzionalità di replay,-->
              <!-- fa comparire affianco all'id acquisto un pulsante per caricare il form del servizio già parzialmente -->
              <!-- pre compilato. In questo caso abbiamo che tale pagina è vista solo dall'utente e non dal referente -->
              <!-- quindi non andiamo a controllare l'entità che visualizza l'informazione -->
              <template v-slot:cell(id)="data">
                <div v-if="row_attributes[ data.item.kind ].replay">
                  {{data.value}}
                  <b-link class="ml-2 replay-button"
                          :to="{ name : row_attributes[ data.item.kind ].replay_route_name, params: { id_acq_replay: data.value } }">
                    <!-- Usiamo il title e non il tooltip boostrap perchè si è visto che quest'ultimo causa saltuarimente -->
                    <!-- un errore di Maximum call stack size exceeded nell'hook beforeDestory della DashMovimenti con conseguente -->
                    <!-- ritardo nella navigazione verso il form da visualizzare -->
                    <font-awesome-icon icon="registered" title="Esegui di nuovo" size='lg'/>
                  </b-link>
                </div>
                <div v-else>
                  {{data.value}}
                </div>
              </template>

              <!-- Slot per la colonna della data created, la mettiamo nel formato italiano -->
              <template v-slot:cell(created)="data">
                {{data.item.created | toitadatetime}}
              </template>

              <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                  chiamata la funzione che prende i dati get_table_items --->
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
                  <strong class="text-primary">Caricamento...</strong>
                </div>
              </template>

              <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
              <template v-slot:empty>
                <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento presente</p>
              </template>

              <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
                  la proprietà "show-empty" alla tabella -->
              <template v-slot:emptyfiltered>
                <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
              </template>
            </b-table>
            <!-- Paginatore e numero di elementi trovati -->
            <p class="text-center">Trovati {{datatable.total_rows}} elementi</p>
            <b-pagination v-model="datatable.current_page" :per-page="datatable.page_size" :total-rows="datatable.total_rows" align="center"></b-pagination>
          </b-col>
        </b-row>
      </template>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="primary" @click="open_close_modal = false">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'TransAnnModal',
  data () {
    return {

      // TABELLA MOVIMENTI
      // Oggetto con le info per la tabella
      datatable : {

        // Definizione delle colonne per la tabella.
        fields: [
          {
            key: 'kind',
            label: 'Tipologia',
            sortable: true,
            tdClass: 'text-center'
          },
          {
            key: 'id',
            label : 'Id Acquisto',
            sortable: true
          },
          {
            key : 'oggetto',
            label: 'Oggetto',
            sortable: true
          },
          {
            key : 'created',
            label: 'Data richiesta',
            sortable: true
          },
          {
            key : 'importo_unitario',
            label: 'Importo €',
            sortable: true,
            tdClass: 'text-center'
          }
        ],

        // Pagina attualmente visualizzata
        current_page : 1,

        // Numero di righe totali
        total_rows : 0,

        // Numero di elementi per pagina
        page_size : 10,

        // Opzioni per il numero di elementi visualizzati
        page_size_opt: [
          { value: 10,  text: '10'  },
          { value: 25,  text: '25'  },
          { value: 50,  text: '50'  },
          { value: 100, text: '100' },
          { value: 500, text: '500' }
        ],

        // Filtro di ricerca
        filter : null

      }
    }
  },
  methods: {
    /**
     * Funzione per prendere gli item della tabella
     * da backend.
     */
    get_table_items : function ( ctx, callback ) {

      const call_url = apiUrl.welfareapi.acqcanceled;
      const params =  { page : ctx.currentPage, page_size : ctx.perPage };

      axios.get( call_url, { params : params } )
      .then( ( response ) => {

        this.datatable.total_rows = response.data.count;
        callback( response.data.results );

      })
      .catch( ( error ) => {
        generalLib.backend_error_message_box( this, error.response.data );
        callback ( [] );
      });

    },
    /**
     * Resetta alcuni dati della tabella per prepararla quando la modale viene aperta
     */
    init_modal_data : function () {
      this.datatable.page = 1;
      this.datatable.page_size = 10;
      this.datatable.total_rows = 0;
      this.datatable.filter = null;
    }
  },
  computed : {
    /* Questa computed può essere anche settata ed è di supporto al v-model, viene
       agganciata al v-model della b-modal per aprirla e chiuderla.
       Quando il valore della prop viene settato ( a true ad esempio perchè vogliamo
       aprire la modale ), viene eseguito il metodo get che restituisce il valore
       stesso della property ( true ) ed apre la modale.
       Al click sul pulsante "chiudi" la computed viene settata a false ( voglio chiudere
       la modale ), questo fa si che sia eseguito il set il quale emette l'evento close
       e torna il valore false.
       Avendo definito in "model" l'evento close come evento di update del v-model,
       registrato l'evento, il suo valore (false) viene settato nella property dal chiamante
       e la finestra si chiude! In questo modo la propery non viene mutata direttamente da
       dal componente stesso. */
    open_close_modal : {
      get() {
        return this.show_modal;
      },
      set(value) {
        this.$emit( 'close', value );
      }
    }
  },
  /* Definendo model possiamo agganciare al componente un suo v-model,
     il quale, pilotato dal componente parent può aprire o chiudere la finestra.
     Il valore del v-model sarà sempre passato alla prop show_modal, allo scattare
     dell'evento close il v-model sarà updatato.
     In questo modo si evita la modifica da dentro il componente della
     prop che è un antipattern e viene segnalato come errore. */
  model : {
    prop: 'show_modal',
    event: 'close'
  },
  props : {
    /**
     * Booleano che indica se visualizzare o meno la modale.
     */
    show_modal : {
      type: Boolean,
      default: false
    },
    /**
     * Gli attributi delle varie righe così come sono definiti
     * nella tabella dei movimenti utente.
     */
    row_attributes : {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Bottoni di replay degli acquisti */
.replay-button {
  color: #ff6a00;
}
.replay-button:hover {
  color: #ffa600;
}
</style>